module.exports = __webpack_public_path__ + "static/adelowo-f09c058c667130d850936ff4840118d4.png";